import { render, staticRenderFns } from "./back-listedhistory.vue?vue&type=template&id=ed3f679a"
import script from "./back-listedhistory.vue?vue&type=script&lang=ts"
export * from "./back-listedhistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports